import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { isEmpty, map } from 'lodash';
import { SiteConfigManager } from '@apollo/core';
import { CLIENT_PROFILE_COMPONENT_TYPES, COMPONENT_TYPES } from '@apollo/routing';
import Label from '../../I18n/Label';
import useTranslate from '../../I18n/Interpreter';
import { getBespokeMarketsRoute, getClientProfileTabs } from '../../../../core/utils';
import { useBespokeMarketsState } from '../../../../state/Bonus/BespokeMarket';

const { CLIENT_PROFILE } = COMPONENT_TYPES;

const HeaderAccountLinks = ({ onClick, skipPaymentLink }) => {
  const clientProfilePath = SiteConfigManager.getComponentPath(CLIENT_PROFILE);
  const t = useTranslate();

  const { markets: bespokeMarkets } = useBespokeMarketsState();

  const tabs = useMemo(() => {
    const tabs = getClientProfileTabs();
    if (skipPaymentLink) {
      return tabs?.filter((t) => t.type !== CLIENT_PROFILE_COMPONENT_TYPES.PAYMENT);
    }
    return tabs;
  }, [skipPaymentLink]);

  return (
    <div className='account_dropdown__links'>
      {!isEmpty(bespokeMarkets) && (
        <NavLink
          to={getBespokeMarketsRoute()}
          activeClassName='active'
          className='account-link'
          onClick={onClick}
        >
          <i
            className='account_dropdown__links__icon icon--bespoke-markets'
            title={t('Bespoke Markets')}
          />
          <Label message='Bespoke Markets' />
          <span className='icon AIcon-angle-right' />
        </NavLink>
      )}
      {map(tabs, ({ name, link, icon }) => (
        <NavLink
          key={link}
          to={`${clientProfilePath}/${link}`}
          activeClassName='active'
          className='account-link'
          onClick={onClick}
        >
          <i className={`account_dropdown__links__icon AkIcon-${icon}`} title={name} />
          <Label message={name} />
          <span className='icon AIcon-angle-right' />
        </NavLink>
      ))}
    </div>
  );
};

export default HeaderAccountLinks;
